import { connect } from 'react-redux';
import { get } from 'lodash';
import CheckAuthentication from './check-authentication.component';
import { goToGetBetaInfo, goToLandingPage } from './check-authentication.actions';
import { ILoginSession } from 'types/session';
import { requestLoginSession } from 'modules/login/login.actions';

export interface IDispatchProps {
    readonly goToGetBetaInfo: () => void;
    readonly goToLandingPage: () => void;
    readonly requestLoginSession: () => void;
}

export interface IStateProps {
    readonly session: ILoginSession | null;
    readonly fetching: boolean;
}

const mapDispatchToProps = (dispatch: Function): IDispatchProps => ({
    goToGetBetaInfo: () => {
        dispatch(goToGetBetaInfo());
    },
    goToLandingPage: () => {
        dispatch(goToLandingPage());
    },
    requestLoginSession: () => {
        dispatch(requestLoginSession());
    }
});

const mapStateToProps = (state: Object): IStateProps => ({
    session: get(state, 'login.loginSession'),
    fetching: get(state, 'login.fetching'),
});

const CheckAuthenticationContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(CheckAuthentication);

export default CheckAuthenticationContainer;
